import Splide from '@splidejs/splide';
import '@splidejs/splide/css';
import { CoasVideoPreview } from "../utilities/youtubeVideo";
import { VideoLocalPreview } from "../utilities/video";
class videoImage {
    constructor() {
        this.containerVideoId = 'containerVideoId';
        this.containerLocalVideoId = 'containerLocalVideo';
        this.initPageConfig();
    }
    initPageConfig() {
        // Cards slider
        new Splide('.abi-ancestors-carousel', {
            arrows: false,
            pagination: true,
            gap: 47,
            perPage: 2,
            padding: '0%',
            breakpoints: {
                767: {
                    gap: 10,
                    perPage: 1,
                    padding: '0%',
                },
            }
        }).mount();
        // Init video component
        const videos = document.querySelectorAll(".abi__card-video");
        if (videos) {
            videos.forEach(video => {
                if (video) {
                    const videoId = video.getAttribute("id");
                    const containerVideo = new CoasVideoPreview(videoId);
                    containerVideo.onInit();
                }
            });
        }
        const videosLocal = document.querySelectorAll(".abi__card-video-local");
        if (videosLocal) {
            videosLocal.forEach(video => {
                if (video) {
                    const videoId = video.getAttribute("id");
                    const containerVideo = new VideoLocalPreview(videoId);
                    containerVideo.onInit();
                }
            });
        }
    }
}
window.addEventListener('load', function () {
    new videoImage();
});
